export const studentsEnrollmentModule = "students-enrollment" as const;

export function normalizeMassar(value: string): string {
  return value.normalize("NFKC").toUpperCase().replace(/[\s-]/g, "");
}

export function normalizeGuardianPhone(value: string): string | null {
  const westernDigits = value
    .normalize("NFKC")
    .replace(/[٠-٩]/g, (digit) => String("٠١٢٣٤٥٦٧٨٩".indexOf(digit)))
    .replace(/[۰-۹]/g, (digit) => String("۰۱۲۳۴۵۶۷۸۹".indexOf(digit)))
    .trim();
  if (!westernDigits || !/^\+?[0-9\s().-]+$/.test(westernDigits)) return null;
  let compact = westernDigits.replace(/[\s().-]/g, "");
  if (compact.startsWith("00")) compact = `+${compact.slice(2)}`;

  if (!compact.startsWith("+")) {
    if (/^0[5-7][0-9]{8}$/.test(compact)) compact = `+212${compact.slice(1)}`;
    else if (/^[5-7][0-9]{8}$/.test(compact)) compact = `+212${compact}`;
    else return null;
  }

  if (compact.startsWith("+2120")) compact = `+212${compact.slice(5)}`;
  return /^\+[1-9][0-9]{7,14}$/.test(compact) ? compact : null;
}

export function normalizeStudentSearch(value: string): string {
  return value
    .normalize("NFKD")
    .replace(/[\u0300-\u036f\u0640\u064b-\u065f\u0670]/g, "")
    .replace(/[أإآٱ]/g, "ا")
    .replace(/ى/g, "ي")
    .replace(/ؤ/g, "و")
    .replace(/ئ/g, "ي")
    .toLocaleLowerCase("fr")
    .replace(/[^\p{L}\p{N}]+/gu, " ")
    .trim()
    .replace(/\s+/g, " ");
}

export interface StudentSearchCriteria {
  readonly query: string;
  readonly page: number;
  readonly pageSize: number;
}
